// extracted by mini-css-extract-plugin
export default {"fileBlock":"TypeFile_fileBlock__ye46n","textBlock":"TypeFile_textBlock__RZWNp","textContent":"TypeFile_textContent__HKgN5"};